module.exports = __webpack_public_path__ + "img/108.784c0014.png";